<template>
  <highlight
    v-if="search"
    :text="nameWithFallback"
    :search="search"
    :ignore-chars="nameHighlightIgnoredChars"
  />
  <span v-else>{{ nameWithFallback }}</span>
</template>

<script lang="ts" setup>
import Highlight from '@/components/shared/misc/Highlight.vue'
import { computed } from '@/composition/vue/compositionApi'
import { emptyStringFallback, nameHighlightIgnoredChars } from '@/utils/string/types'

const props = defineProps<{
  name?: string
  search?: string
}>()

const nameWithFallback = computed(() => props.name || emptyStringFallback)
</script>
